module.exports = __webpack_public_path__ + "static/media/certificado_de_cobertura_seguro_bicicletas_v2.fafe7dbe.pdf";